import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSplit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.53 9.47c.141.14.22.331.22.53v6.5a.75.75 0 0 1-1.5 0v-6.19L2.47 3.53a.75.75 0 0 1 1.06-1.06z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M6.691 3a.75.75 0 0 1-.75.75H3.75v2.191a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25h2.941a.75.75 0 0 1 .75.75m10.839-.53a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 1 1-1.06-1.06l6.5-6.5a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.309 3a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 .75.75v2.941a.75.75 0 0 1-1.5 0V3.75h-2.191a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSplit;
